import React from "react";
import "./CameraLoader.css";

function CameraLoader({ text = "Loading..." }) {
  return (
    <div className="cam-loader">
      <div className="cam-loader-camera">
        <div className="cam-body">
          <div className="cam-lens-ring">
            <div className="cam-lens">
              <div className="cam-lens-inner"></div>
            </div>
          </div>
          <div className="cam-flash"></div>
          <div className="cam-grip"></div>
        </div>
        <div className="cam-shutter-line"></div>
      </div>
      <p className="cam-loader-text">{text}</p>
    </div>
  );
}

export default CameraLoader;
